import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { DocumentReportsListingModel } from 'common/models/page-models/reports/document-reports/document-report-grid-model';
import { DocumentReportsModel } from 'common/models/page-models/reports/document-reports/document-report-data-model';
import { DocumentReportsGridPostParams } from 'common/models/page-models/reports/document-reports/document-report-grid-params';
import { DocumentChartsModel } from 'common/models/page-models/reports/document-reports/document-reports-charts.model';


@Injectable({
  providedIn: 'root'
})
export class DocumentReportsDataService extends GridDataService<DocumentReportsListingModel, DocumentReportsModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.fetchReportData, http, ss);
  }

  createInstance(): DocumentReportsListingModel {
    return new DocumentReportsListingModel();
  }

  getDeleteUrl() {
    return '';
  }

  getGridParams(param): GridPostParams {
    return new DocumentReportsGridPostParams();
  }

  override transformDataModel(data: any[], param: any) {
    super.transformDataModel(data, param);
    if (data.hasOwnProperty(param)) {

      data[param].forEach(element => {
        // const avgScore = new Headers('Average Score', 'avgScore', false, false, 'text');
        element.Signedurl_fileName = !element.Signedurl_fileName || element.Signedurl_fileName === null ? '-' :  element.Signedurl_fileName;

      });
    } else {
      // console.log('No records found for given combination');
      this.ss.showError('No records found for given combination')
    }
    return data;
  }

  override modifyGridPostParams(queryParams) {
    let payload = this.getGridParams(queryParams);
    // console.log(queryParams)
    if (queryParams.transferData !== null) {
      payload['batch_search'] = queryParams.transferData.selectedBatch === null ? '' : queryParams.transferData.selectedBatch;
      payload['region_search'] = queryParams.transferData.selectedRegion === null ? '' : queryParams.transferData.selectedRegion;
      payload['branch_search'] = queryParams.transferData.selectedBranch === null ? '' : queryParams.transferData.selectedBranch;
      payload['state_search'] = queryParams.transferData.selectedState === null ? '' : queryParams.transferData.selectedState;
      payload['gender_search'] = queryParams.transferData.selectedGender === null ? '' : queryParams.transferData.selectedGender;
      payload['isAnnual'] = queryParams.transferData.selectedDocumentType === null ? '' : queryParams.transferData.selectedDocumentType;
      payload['periodValue'] = queryParams.transferData.selectedPeriod === null ? '' : queryParams.transferData.selectedPeriod;
      payload['documentTypeId'] = queryParams.transferData.selectedDocument === null ? '' : queryParams.transferData.selectedDocument;
      payload['upload_search'] = queryParams.transferData.selectedUploadFilter === null ? '' : queryParams.transferData.selectedUploadFilter;
    }
    return payload;
  }

  override prepareChartsData(apiData) {
    const chartsModel = new DocumentChartsModel();

    const studentCount = this.countUploadedAndNotUploaded(apiData);
    const batchWiseCounts =this.countUploadedAndNotUploadedBatchWise(apiData);                                   
    const categories = Object.keys(batchWiseCounts);
    const uploadedData = categories.map(batch => ({
      y: batchWiseCounts[batch].uploadedCount,
      color: '#f5f5dc'
    }));
    const notUploadedData = categories.map(batch => ({
      y: batchWiseCounts[batch].notUploadedCount,
      color: '#ffe5b4'
    }));
    // // console.log(studentCount, studentCountYearWise);

    chartsModel.documentStatusChart.options = {
      chart: {
        type: 'pie',
        width: 320, // Adjust chart width
        height: 300 // Adjust chart height
      },
      credits: {
        enabled: false // Disable the Highcharts credits
      },
      title: {
        text: 'Total Students:  ' + apiData.length,
        style: {
          color: '#000000',
          fontSize: '1em',
        }
      },
      series: [
        {
          type: 'pie', // Add the type property here
          data: [
            {
              name: 'Uploaded:' + studentCount.uploadedCount,
              y: studentCount.uploadedCount,
              // y: 5,
              color: '#e6e6fa'
            },
            {
              name: 'Non-Uploaded:' + studentCount.notUploadedCount,
              y: studentCount.notUploadedCount,
              // y: 8,
              color: '#ffc0cb'
            }
          ],
          dataLabels: {
            enabled: false,
            inside: true,
            distance: 6 // Adjust the distance of labels from the slices
          }
        }
      ]
    };

    chartsModel.documentStatusChart.data = {
      uploadedData: studentCount.uploadedCount,
      uploadedColor: '#e6e6fa',
      nonUploadedData: studentCount.notUploadedCount,
      nonUploadedColor: '#ffc0cb'
    }

    chartsModel.documentStatusChartPeriodWise= {
        chart: {
          type: 'column',
        //   height: 360
        },
        title: {
          text: 'Uploaded vs Not Uploaded (Batch-wise)',
          align: 'left'
        },
        xAxis: {
          categories: categories,
          title: {
            text: 'Batch'
          },
          labels: {
            rotation: -45
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Number of Students'
          }
        },
        tooltip: {
          shared: true,
          valueSuffix: ''
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [
          {
            name: 'Uploaded',
            color: '#f5f5dc',
            data: uploadedData
            
          },
          {
            name: 'Not Uploaded',
            color: '#ffe5b4',
            data: notUploadedData
          }
        ]
      };

    return chartsModel;
  }

  countUploadedAndNotUploaded(students) {
    let uploadedCount = 0;
    let notUploadedCount = 0;

    students.forEach(student => {
        // console.log(student)
      // Check if any document key is not null
      const hasUploaded = student.Signedurl_fileName !== null && student.Signedurl_fileName !== '-';
        // console.log(hasUploaded)
      if (hasUploaded) {
        uploadedCount++;
      } else {
        notUploadedCount++;
      }
    });

    return { uploadedCount, notUploadedCount };
  }

  countUploadedAndNotUploadedBatchWise(students: any[]) {
    const batchWiseCounts = {};
  
    students.forEach(student => {
      const batchName = student.batch_number || 'Unknown Batch';
      if (!batchWiseCounts[batchName]) {
        batchWiseCounts[batchName] = { uploadedCount: 0, notUploadedCount: 0 };
      }
  
      const hasUploaded = student.Signedurl_fileName !== null && student.Signedurl_fileName !== '-';
  
      if (hasUploaded) {
        batchWiseCounts[batchName].uploadedCount++;
      } else {
        batchWiseCounts[batchName].notUploadedCount++;
      }
    });
  
    return batchWiseCounts;
  }
}
